export const knownTags = [
	'draft',
	'created',
	'design-started',
	'design-ended',
	'design-target',
	'design-due',
	'bid',
	'delivery-requested',
	'delivery-scheduled',
	'rework',
] as const;
